import React, { Component } from 'react';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import Link from '@components/Link';
import s from './ArticlesBanner.css';

class ArticlesBanner extends Component {
  render() {
    return (
      <Link to={`/articles/${this.props.id}`}>
        <div
          // className={s.cardContainer}
          className={
            this.props.isMobile
              ? `${s.cardContainer} ${s.mobileBanner}`
              : `${s.cardContainer}`
          }
        >
          <div className={s.cardGradient} />
          <img
            // className={s.articles__img}
            className={
              this.props.isMobile
                ? `${s.articles__img} ${s.img_round}`
                : `${s.articles__img}`
            }
            src={`${this.props.imageUrl}?w=640`}
            alt="articles banner image"
          />
          <span
            // className={s.cardTitle}
            className={
              this.props.isMobile
                ? `${s.cardTitle}`
                : `${s.cardTitle} ${s.desktop_font_size}`
            }
          >
            {this.props.title}
          </span>
        </div>
      </Link>
    );
  }
}

export default withStyles(s)(ArticlesBanner);
